import { FC } from 'react';
import { Link } from 'react-router-dom';
import classes from '../../asset/css/subscription-detail/footer.module.css';

export const Footer: FC<{}> = ({}) => {
  return (
    <>
      <div className={classes.mypage_subsc_foot_buttons}>
        <Link to="/cancel">いちもくさんに解約する</Link>
        <a href="mailto:email@example.com" target="_top">
          返品・返金 いつでも承ります
        </a>
      </div>
    </>
  );
};
